/**
 * Single anomaly log model. 
 */
export interface AnomalyLog {
	anomalyLogId: number;
	type: DiaryLogType;
	subtype?: string;
	date: Date;
	isRead: boolean;
	updateValue: boolean;
	frameId: string;
}

export enum DiaryLogType {
	PersonalGoalSet = 'PersonalGoalSet',
	PinSiteCareDone = 'PinSiteCareDone',
	StrutAdjustmentDone = 'StrutAdjustmentDone',
	StrutAdjustmentPostponed = 'StrutAdjustmentPostponed',
	MotivationalMessageRead = 'MotivationalMessageRead',
	DailyMoodSurveyAnswered = 'DailyMoodSurveyAnswered',
	AppStateChanged = 'AppStateChanged',
	PrescriptionUpdated = 'PrescriptionUpdated',
	MotivationalMessageFlag = 'MotivationalMessageFlag',
	TreatmentRevoked = 'TreatmentRevoked'
}